'use strict';

var crypto = require('crypto');
var lib = require('../../lib');
var types = require('../../lib/types');
var bls12381 = require('./bls12381');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var crypto__default = /*#__PURE__*/_interopDefault(crypto);

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const generateKeyPair = /* @__PURE__ */ __name(async (keyPairOptions) => {
  const { type, seedBase58, privateKeyBase58, publicKeyBase58 } = keyPairOptions;
  if (!type) {
    throw new Error("Invalid key pair type");
  }
  let seed;
  if (type !== types.VerificationType.EcdsaSecp256k1RecoveryMethod2020) {
    if (seedBase58) {
      seed = await lib.parseMultibase("z" + seedBase58);
    }
    keyPairOptions.seed = seed ?? Uint8Array.from(crypto__default.default.randomBytes(32));
  }
  let generatedKeyPair;
  switch (type) {
    case types.VerificationType.Ed25519VerificationKey2018:
      throw new Error("Unsupported key pair type");
    case types.VerificationType.Bls12381G2Key2020:
      generatedKeyPair = await bls12381.generateBls12381KeyPair(keyPairOptions);
      break;
    default:
      throw new Error("Unsupported key pair type");
  }
  if (seedBase58) {
    generatedKeyPair = generatedKeyPair;
    if (privateKeyBase58 && privateKeyBase58 !== generatedKeyPair.privateKeyBase58) {
      throw new Error("Private key does not match");
    }
    if (publicKeyBase58 && publicKeyBase58 !== generatedKeyPair.publicKeyBase58) {
      throw new Error("Public key does not match");
    }
  }
  return generatedKeyPair;
}, "generateKeyPair");

exports.generateKeyPair = generateKeyPair;
